import { render, staticRenderFns } from "./Findpass2.vue?vue&type=template&id=db061d2e&"
import script from "./Findpass2.vue?vue&type=script&lang=js&"
export * from "./Findpass2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports